module.exports = __webpack_public_path__ + "809e55bbb1903c63092078c63b35833d.svg";